import React from 'react';
import styled from 'styled-components/native';
import { ViewStyle } from 'react-native';
import { useAppRouter } from '@/hooks/use.app.router';
import { AppTextView } from '@/components/base/app.text.view';
import { AppIconButton } from '@/components/base/app.icon.button';
import { Box } from '@/components/base/box';
import { themeVal, wpVal } from '../../utils';

interface Props {
  text?: string;
  backButton?: boolean | (() => any);
  style?: ViewStyle;
  backButtonColor?: string;
}
function BaseScreenHeader({ text, style, backButtonColor, backButton = true }: Props) {
  const { goBack } = useAppRouter();
  return (
    <TitleContainer style={style}>
      {backButton && <AppIconButton onPress={typeof backButton === 'function' ? backButton : goBack} icon={'back'} color={backButtonColor} />}
      <AppTextView variant={'medium'} text={text} textColor={'white'} />
    </TitleContainer>
  );
}

const TitleContainer = styled(Box)`
  background-color: ${themeVal((t) => t.colors.jade)};
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 15px;
  padding-left: 25px;
`;

export const ScreenHeader = React.memo(BaseScreenHeader);
